import { render, staticRenderFns } from "./NewsUpdateForm.vue?vue&type=template&id=0f9a3b71&scoped=true"
import script from "./NewsUpdateForm.vue?vue&type=script&lang=js"
export * from "./NewsUpdateForm.vue?vue&type=script&lang=js"
import style0 from "./NewsUpdateForm.vue?vue&type=style&index=0&id=0f9a3b71&prod&lang=scss&scoped=true"
import style1 from "./NewsUpdateForm.vue?vue&type=style&index=1&id=0f9a3b71&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9a3b71",
  null
  
)

export default component.exports